export async function checkAuth() {
  try {
    const token = localStorage.getItem('token');
    console.log('本地存储中的token:', token);

    // 解析token
    if (token) {
      const [header, payload, signature] = token.split('.');
      const decodedPayload = JSON.parse(atob(payload));
      console.log('解析后的token payload:', decodedPayload);
    }

    // 发送调试请求
    const response = await fetch('/api/admin/debug/auth-check', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await response.json();
    console.log('权限检查结果:', data);
    
    return data;
  } catch (error) {
    console.error('权限检查失败:', error);
    return null;
  }
} 